import { colors } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import { TextFieldProps } from "@mui/material/TextField";

import palette from "./palette";

// Add custom variant for white outlined button
declare module "@mui/material/Button" {
  interface IButtonPropertiesVariantOverrides {
    white: true;
  }
}

const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        height: "fit-content",
      },
    },
    variants: [
      {
        props: { size: "small" as ButtonProps["size"] },
        style: {
          fontSize: "14px",
          lineHeight: 1.33,
          padding: "8px 16px",
        },
      },
      {
        props: { size: "medium" as ButtonProps["size"] },
        style: {
          fontSize: "16px",
          lineHeight: 1.5,
          padding: "8px 24px",
        },
      },
      {
        props: { size: "large" as ButtonProps["size"] },
        style: {
          fontSize: "18px",
          lineHeight: 1.33,
          padding: "12px 32px",
        },
      },
      {
        props: {
          color: "primary" as ButtonProps["color"],
          variant: "contained" as ButtonProps["variant"],
        },
        style: {
          "&:disabled": {
            "*": {
              color: `${palette.text.disabled} !important`,
            },
            background: palette.action.disabledBackground,
          },
          "&:hover": {
            background: palette.primary.dark,
          },
          color: `${palette.common.white}`,
          "svg, & .MuiButton-startIcon, & .MuiButton-endIcon": {
            color: `${palette.common.white} !important`,
          },
        },
      },
      {
        // Custom variant for white outlined button
        props: { variant: "white" as ButtonProps["variant"] },
        style: {
          "&:hover": {
            "& .MuiButton-startIcon, & .MuiButton-endIcon, & svg": {
              color: colors.common.white,
            },
            borderColor: colors.common.white,
          },
          "& .MuiButton-startIcon, & .MuiButton-endIcon, & svg": {
            color: colors.grey[400],
          },
          backgroundColor: "transparent",
          border: `1px solid ${colors.grey[600]}`,
          color: colors.common.white,
          transition: "all .2s ease-in-out",
        },
      },
    ],
  },
  MuiDataGrid: {
    styleOverrides: {
      cell: {
        lineHeight: 1.5,
        overflow: "visible",
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        "&:hover": {
          color: colors.blue[800],
        },
        color: colors.blue[600],
        transition: "all .2s ease-in-out",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: `${palette.secondary.main} !important`,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: `${palette.primary.main}`,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.grey[400],
        },
      },
    },
  },
  MuiTextField: {
    variants: [
      {
        props: {
          color: "secondary" as TextFieldProps["color"],
          variant: "outlined" as TextFieldProps["variant"],
        },
        style: {
          "&::placeholder": {
            color: colors.grey[600],
          },
          "& .MuiInputBase-input": {
            color: palette.text.primary,
          },
          "& .MuiInputBase-root": {
            backgroundColor: `${colors.grey[50]} !important`,
          },
          "& .MuiInputLabel-root": {
            color: colors.grey[600],
          },
        },
      },
    ],
  },
  MuiTooltip: {
    defaultProps: {
      enterDelay: 1000,
    },
    styleOverrides: {
      tooltip: {
        backgroundColor: colors.grey[800],
        color: palette.common.white,
        fontSize: "14px",
        fontWeight: "600",
        maxWidth: "unset",
        padding: "8px 16px",
      },
    },
  },
};
export default components;
